module.exports = __webpack_public_path__ + "static/0c0418fe-d324-4ab2-978a-e8201c646ca1-459b107559f4623b8ce47232b4255ec6.woff";